var EventType;
(function (EventType) {
    EventType["TxnGroupSimulated"] = "TxnGroupSimulated";
    EventType["AppCompiled"] = "AppCompiled";
})(EventType || (EventType = {}));

export { EventType };
//# sourceMappingURL=lifecycle-events.mjs.map
